// components/Navbar.jsx
import React from "react";
import { NavLink } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

import ThemeToggle from "./ThemeToggle";

export default function Navbar() {
    const { user, logout } = useAuth();

    return (
        <nav className="navbar">
            <NavLink to="/" className="navbar__brand">TWW3 FORUM</NavLink>

            <div className="navbar__links">
                <ThemeToggle />

                {/* Public */}
                <NavLink to="/forum" className="btn">Forums</NavLink>
                <NavLink to="/about" className="btn">About</NavLink>

                {/* Authenticated */}
                {user ? (
                    <>
                        <NavLink to={`/profile/${user.id}`} className="btn">Profile</NavLink>

                        {user.role === "admin" && (
                            <NavLink to="/admin" className="btn">Admin</NavLink>
                        )}

                        <button onClick={logout} className="btn btn--danger">
                            Logout ({user.username})
                        </button>
                    </>
                ) : (
                    <>
                        <NavLink to="/login" className="btn">Login</NavLink>
                        <NavLink to="/register" className="btn">Register</NavLink>
                    </>
                )}
            </div>
        </nav>
    );
}